import React, { useState, useEffect } from 'react';
import { getCaseStatus, getCaseStatusString } from '../../../../item/ItemRecruitmentContractorStatus';
import { SingleText, SingleInput } from '../../Res/BaseInput';
import { ContentBox } from '../ContentBox';
import { ReqRecruitmentContractorCaseInfo, VIEW_CASESTATUS1 } from '../../../../item/ItemRecruitmentContractor';
import { CancelSubmitButton } from '../../Res/BaseButton';
import { DatePickerInput } from 'rc-datepicker';
import moment from 'moment';
import { AutoSelect } from '../../Res/AutoSelect';
import { api_getCaseOwnerList } from '../../../../api/apiAccount';
import { toRevise } from './ReviseSOPTools';
import { getOnlyDate } from '../../../../item/ItemTools';
import Swal from 'sweetalert2';

/**
 * 案件管轄者
 * @param {*} param0 
 */
export function ReviseCaseOwner({ item, action, setIsLoading, vw_status }) {
    const [mItem, setItem] = useState({})
    const [caseOwner, setCaseOwner] = useState("")
    const [caseOwnerName, setCaseOwnerName] = useState("")

    const [caseComment, setCaseComment] = useState("")
    const [newCaseOwner, setNewCaseOwner] = useState("")
    const [newCaseOwnerName, setNewCaseOwnerName] = useState("")
    const [newCaseOwnerInput, setNewCaseOwnerInput] = useState("")
    const [caseOwnerList, setCaseOwnerList] = useState([])
    const [reservError, setReservError] = useState(false)

    const description = "變更 “案件管轄者”"

    useEffect(() => {
        if (item !== undefined && item !== mItem) {
            console.log(item)
            setItem(item)
            setCaseOwner(item.caseOwner)
            setCaseOwnerName(item.caseOwnerName)
            var mReqRecruitmentContractorCaseInfo = new ReqRecruitmentContractorCaseInfo({})
            mReqRecruitmentContractorCaseInfo.fromJson(item.caseInfo)
            console.log(mReqRecruitmentContractorCaseInfo)
            
        }
    }, [item])

    useEffect(() => {
        if (caseOwner !== undefined && caseOwner !== "")
            getCaseOwnerList()
    }, [caseOwner])

    function getCaseOwnerList() {
        setIsLoading(true)
        console.log(newCaseOwnerInput)
        api_getCaseOwnerList({
            caseOwner,
            name: newCaseOwnerInput,
            success: (result) => {
                console.log(result)
                setCaseOwnerList(result.list)
                setIsLoading(false)
            },
            failure: (err) => {
                setIsLoading(false)
            }
        })
    }

    function toCancel() {
        action(VIEW_CASESTATUS1)
    }

    function toAction() {
        if (newCaseOwner === "") {
            Swal.fire({
                type: 'error',
                title: '請選擇 新的案件管轄者',
            }).then(() => {
            })
            return
        }
        toRevise(mItem, "案件管轄者已變更", {
            setIsLoading,
            description: getOnlyDate() + " 案件管轄者由" + caseOwnerName+"變更成"+newCaseOwnerName,
            comment: caseComment,
            caseOwner: newCaseOwner,
        })
    }

    var superTitle = description
    var title = ""
    var content =
        <>
            <div className="row">
                <div className="col-md-12">
                    {vw_status}
                    <AutoSelect
                        title={"請選擇 新的案件管轄者"}
                        attr={caseOwnerList}
                        val={newCaseOwner}
                        v={'accountId'}
                        n={'nickName'}
                        action={setNewCaseOwner}
                        feedback={setNewCaseOwnerName}
                        inputFeedback={setNewCaseOwnerInput}
                        size={3}
                    />
                </div>
            </div>
            <div className="hr-line-dashed"></div>
            <div className="row">
                <div className="col-md-12">
                    <SingleInput title={"本次作業的評論/備註"} val={caseComment} action={setCaseComment} placeholder={"請儘量簡短"} size={6} />
                </div>
            </div>
        </>

    var footer =
        <div className="row text-right ">
            <div className="col-sm-12">
                <CancelSubmitButton cancelAction={toCancel} submitName={"確定"} submitAction={toAction} isRight={true} />
            </div>
        </div>

    return (
        <ContentBox superTitle={superTitle} title={title} titleSize={6} content={content} footer={footer} hasDrawer={false} />
    )
}